import { render } from "./SubscriptionList.vue?vue&type=template&id=5bdcd04e&scoped=true"
import script from "./SubscriptionList.vue?vue&type=script&lang=js"
export * from "./SubscriptionList.vue?vue&type=script&lang=js"

import "./SubscriptionList.vue?vue&type=style&index=0&id=5bdcd04e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdcd04e"]])

export default __exports__